







import { Component, Vue } from "vue-property-decorator";
import { getInfoOfdxkt } from "../../service/index";
import { DaXinKeTangDataType } from "../../service/type";
const win: any = window;
@Component({})
export default class NoticeBar extends Vue {
  //兜底文案
  private text = "打新必看 手把手带你学会打新股新债";
  //兜底跳转链接
  private jumpUrl =
    "//mams.10jqka.com.cn/new/server/html/62131.html?enter_sign=prd_xtzkhdxkt";

  private async created() {
    const res: DaXinKeTangDataType | null = await getInfoOfdxkt();
    if (res && res.daxinketang && res.daxinketang.length) {
      const data = res.daxinketang.find((item) => {
        //3550是区分多条数据项的标识，在接口中表示打新股新债对应的数据项
        return String(item.data_id) === "3550";
      });
      this.text = data!.wenan;
      this.jumpUrl = data!.url.url;
    }
  }

  //跳转打新股新债
  private handleJump() {
    if (this.jumpUrl) {
      win.F10Utils.jumpToLink({
        url: this.jumpUrl,
      });
    }
  }
}
